"use strict";
var $ = require("../internals/export");
var call = require("../internals/function-call");
var uncurryThis = require("../internals/function-uncurry-this");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toString = require("../internals/to-string");
var fails = require("../internals/fails");
var $Array = Array;
var charAt = uncurryThis("".charAt);
var charCodeAt = uncurryThis("".charCodeAt);
var join = uncurryThis([].join);
var $toWellFormed = "".toWellFormed;
var REPLACEMENT_CHARACTER = "\uFFFD";
var TO_STRING_CONVERSION_BUG = $toWellFormed && fails(function() {
  return call($toWellFormed, 1) !== "1";
});
$({ target: "String", proto: true, forced: TO_STRING_CONVERSION_BUG }, {
  toWellFormed: function toWellFormed() {
    var S = toString(requireObjectCoercible(this));
    if (TO_STRING_CONVERSION_BUG) return call($toWellFormed, S);
    var length = S.length;
    var result = $Array(length);
    for (var i = 0; i < length; i++) {
      var charCode = charCodeAt(S, i);
      if ((charCode & 63488) !== 55296) result[i] = charAt(S, i);
      else if (charCode >= 56320 || i + 1 >= length || (charCodeAt(S, i + 1) & 64512) !== 56320) result[i] = REPLACEMENT_CHARACTER;
      else {
        result[i] = charAt(S, i);
        result[++i] = charAt(S, i);
      }
    }
    return join(result, "");
  }
});
